import fileSize from "filesize";
import { isInteger, isString } from "lodash";
import moment, { Moment } from "moment";
// import { IArchiveItemSet } from "./components/panels/Archive/Archive.model";
// import { callNano } from "./helpers/callNano";
// import { nanos as archiveNanos } from './components/panels/Archive/nanoServives';

export type IAnyMetadata = any
export function getJobContent(job: any, subType: string) {
  if (!job || job === 0) return null;
  return job.info.find((item: any) => item.subType === subType)?.info.content;
}

export function getCurrentStamp() {
  const date = new Date()
  return date.getDay().toString() + date.getHours().toString() + date.getMinutes().toString() + date.getSeconds().toString() + date.getMilliseconds().toString()
}

export function secondFormat(seconds: number) {
  const date = new Date(seconds)
  const hh = date.getUTCHours()
  const mm = date.getUTCMinutes()
  const ss = pad(date.getUTCSeconds())
  // const ms = pad(date.getMilliseconds())
  if (hh) {
    return `${hh}:${pad(mm)}:${ss}`
  }
  return `${mm}:${ss}`
}

export function formatDateTime(time, format = "DD.MM.YYYY HH:mm:ss") {
  return moment.utc(time).local().format(format)
}

export function timeToSeconds(time) {
  const timeA = time.split(':')
  let pos = -1;
  if (timeA.length === 1) {
    try {
      pos = parseInt(timeA[0])
    } catch (error) {
    }
  } else if (timeA.length === 2) {
    try {
      pos = parseInt(timeA[0]) * 60 + parseInt(timeA[1])
    } catch (error) {
    }
  } else if (timeA.length === 3) {
    try {
      pos = (parseInt(timeA[0]) * 60 * 60) + (parseInt(timeA[1]) * 60) + parseInt(timeA[2])
    } catch (error) {

    }
  }

  return isInteger(pos) ? pos : -1
}

export function stringToMoment(str: string): Moment {
  let datetime = str?.split(' ')
  let date = datetime[0]
  let time = datetime[1]
  let dateParts = date.split('.')
  let mdate = dateParts[2] + "-" + dateParts[1] + "-" + dateParts[0]

  return moment.utc(mdate + " " + time)
}

function pad(string) {
  return ('0' + string).slice(-2)
}

export interface IFilter {
  key: string;
  search: any;
  type: string;
}

export function filterItems(items: any[], filters: IFilter[]) {
  return items?.filter(item => {
    let found = true;
    if(!item) return false;
    filters.forEach(qu => {
      let keys = qu.key.split('.')
      let toSearch = keys.length === 1 ? item[qu.key] : item[keys[0]][keys[1]]
      if (qu.type === 'checkbox')
        found = found && (toSearch === qu.search || (toSearch !== null) === qu.search);
      if (qu.type === 'text' && qu.search.trim() !== '')
        found = found && toSearch?.replace(' ', '').toUpperCase().search(qu.search.replace(' ', '').toUpperCase()) >= 0;
    })

    return found
  })
}

export function colorFromString(id: string): string {
  
  if(!id) return 'black'

  let r1 = id.length > 0 ? id.charCodeAt(0) * 9 % 100 : 0;
  let r2 = id.length > 4 ? id.charCodeAt(4) * 8  % 80 : 0 ;

  let g1 = id.length > 1 ? id.charCodeAt(1) * 3 % 100 : 0;
  let g2 = id.length > 5 ? id.charCodeAt(5) * 8  % 80 : 0 ;

  let b1 = id.length > 3 ? id.charCodeAt(3) * 7 % 80 : 0;
  let b2 = id.length > 6 ? id.charCodeAt(6) * 8  % 80 : 0 ;

  return `rgb(${r1 + r2},${g1 + g2},${b1 + b2})`;
  
}

export const renderCell = (type, data) => {
  switch (type) {
      case 'duration':
          return !data ? '' : secondFormat(data * 1000)

      case 'date':
          return moment(data).format('DD.MM.YYYY H:m:s')

      case 'size': return !data ? '0' :fileSize(data)
      
      case 'dimensions':
          return data?.width ? `${data?.width} X ${data?.height}` : ''

      default:
        return data;
  }
  
  return data?.toString()
}


export function normalizePathesInMetadata(metadata: IAnyMetadata): IAnyMetadata{
  let newMetadata = Object.assign({}, metadata)
  Object.keys(newMetadata).forEach(key => {
    if(isString(newMetadata[key])){
      newMetadata[key] = normalizePath(newMetadata[key])
    }
  })

  return newMetadata
}

export function normalizePath(path: string): string {
  path = path.replace(/(\\+|\/+)/g, "\\");
  return path.replace(/^([\\/]+)/, "\\\\");
}
